import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentMenuItem } from 'reducers/menu/selectors';
import Page from './Page';
import { useRouteMatch } from 'react-router';

const SectionContainer = () => {
  const match = useRouteMatch();
  const isHomePage = match.path === '/';
  const currentMenuItem = useSelector((state) => selectCurrentMenuItem(state, { match }));

  if (!currentMenuItem) return null;

  return <Page currentMenuItem={currentMenuItem} isHomePage={isHomePage} />;
};

export default SectionContainer;
